import React from "react";
import { Flex, Box, styled } from "@acko-tech/building-blocks.ui.common";

const Wrapper = styled(Flex)`
  background: white;
  padding: 16px 0px 150px;
  align-items: center;
  justify-content: center;

  @media (min-width: 768px) {
    background: #f8f7fc;
    padding: 60px 0px 150px;
    align-items: normal;
    justify-content: center;
    min-height: calc(100vh - 150px);
  }

  ${props => props.styles};
`;

const InnerWrapper = styled(Box)`
  width: 90%;

  @media (min-width: 768px) {
    display: flex;
    justify-content: space-between;
    width: ${props =>
      props && props.innerWrapperWidth ? props.innerWrapperWidth : "800px"};
    gap: 60px;
  }

  ${props => props.styles};
`;

export const CardContainer = styled(Box)`
  @media (min-width: 768px) {
    background-color: #ffffff;
    border-radius: 1rem;
    padding: 30px;
  }
`;

export const LeftContainer = styled(Box)`
  width: 25%;
  height: max-content;
  position: sticky;
  top: 50px;

  @media (max-width: 768px) {
    display: none;
  }

  ${props => props.styles};
`;

export const ContentContainer = styled(Box)`
  @media (min-width: 768px) {
    width: ${props => (props && props.width ? props.width : "70%")};
  }

  ${props => props.styles};
`;

interface Props {
  children: any;
  forwardedRef?: any;
  styles?: any;
  clickHandler?: Function;
  innerWrapperWidth?: string;
}

const HybridWrapper = ({
  children,
  forwardedRef,
  styles,
  clickHandler,
  innerWrapperWidth
}: Props) => {
  return (
    <Wrapper
      styles={styles}
      ref={forwardedRef && forwardedRef}
      onClick={() => {
        clickHandler && clickHandler();
      }}
    >
      <InnerWrapper innerWrapperWidth={innerWrapperWidth}>
        {children}
      </InnerWrapper>
    </Wrapper>
  );
};

export default HybridWrapper;
